import type { ZodError } from 'zod';

// Dev-only toast styling — deliberately outside the MUI palette (neon green on
// black, monospace, dashed border) so schema-mismatch toasts can't be confused
// with regular axios-error toasts in the project's top-right toast stack.
// Single ToastContainer (DraggableToastContainer) means per-toast `position`
// is ignored; visual distinction does the work instead.
export const SCHEMA_TOAST_STYLE = {
  background: '#0a0a0a',
  color: '#22c55e',
  border: '2px dashed #22c55e',
  fontFamily: '"Fira Code", "Courier New", monospace',
  fontSize: '13px',
  fontWeight: 500,
  padding: '15px',
  boxShadow: '0 0 16px rgba(34, 197, 94, 0.4)',
} as const;

// Thrown when an endpoint's path/query/body/response doesn't match its declared
// Zod schema. Inputs are validated regardless of env (drift is impossible for
// our own code, so any mismatch is a bug). Response is validated in non-prod
// builds for loud failure (throw + toast + console badge); in production no
// throw, no toast — only the console badge plus Sentry telemetry under
// `api-zod-drift` — see endpoint.ts.
export class ApiSchemaError extends Error {
  constructor(
    public readonly section: 'path' | 'query' | 'body' | 'response',
    public readonly method: string,
    public readonly url: string,
    public readonly zodError: ZodError,
  ) {
    super(`[API ${section}] ${method} ${url} — ${zodError.issues.length} issue(s)`);
    this.name = 'ApiSchemaError';
  }
}
